import { ref } from "vue";
import { useRouter } from "vue-router";
import { useSurveyStore } from "@stores/survey/survey";
import { useSurveyDesignStore } from "@stores/survey/setup/surveyDesign";
import { useSurveyTitleStore } from "@stores/survey/setup/surveyTitle";
import { storeToRefs } from "pinia";

export function useInitializeSurveyButton() {
  const router = useRouter();
  const isGenerating = ref(false);
  const loadingText = ref("");
  const surveyStore = useSurveyStore();
  const surveyDesignStore = useSurveyDesignStore();
  const surveyTitleStore = useSurveyTitleStore();

  const { getCurrentDesign, isPromptEmpty, isFileMissing, isTemplateMissing, isCreatingSurvey } =
    storeToRefs(surveyDesignStore);
  const { isTitleEmpty } = storeToRefs(surveyTitleStore);

  const handleClick = async () => {
    await generateCards();
    if (["ai_powered", "word"].includes(getCurrentDesign.value)) {
      router.push({ name: "root" });
    } else {
      router.push({ name: "SurveyQuestions", params: { token: surveyStore.token } });
    }
  };

  const generateCards = async () => {
    try {
      loadingText.value = ["ai_powered", "word"].includes(getCurrentDesign.value)
        ? "Launching generation..."
        : "Creating survey...";
      isGenerating.value = true;
      if (isCreatingSurvey.value) {
        await surveyStore.create();
      } else {
        await surveyStore.resetCards();
      }
    } finally {
      isGenerating.value = false;
    }
  };

  return {
    handleClick,
    generateCards,
    isGenerating,
    loadingText,
    isTitleEmpty,
    isPromptEmpty,
    isFileMissing,
    isTemplateMissing,
  };
}
